<template>
    <div class="container-fluid">
        <h1>Welcome to Admin Settings Page</h1>
        <v-btn dark color="red" large><small style="font-size: 9px" v-html="lookUp()"></small></v-btn>
    </div>
</template>

<script>
export default {
  data() {
      return {
          name: `Central<br/>Analytics<br/>Repository`
      }
  },
  methods: {
      lookUp() {
          return this.name;
      }
  }
}
</script>




// WEBPACK FOOTER //
// Settings.vue?cd57c5fa